import { Component, Input } from "@angular/core";
import { GpFileController, IPopupContentComponent, IToolbarItem, MessageBox } from "@geolib/geoappbase-client";
import DxPopup from "devextreme/ui/popup";
import IDataset from "../../IDataset";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "extended-tech-reject-dialog",
    templateUrl: "./extendedTechRejectDialog.html",
    imports: [FormsModule, TranslatePipe, GpFileController],
})
export default class ExtendedTechRejectDialog implements IPopupContentComponent {

    @Input() public dataset: IDataset;
    @Input() public onFileSelect: (files: File[]) => void;
    @Input() public extendedTechApprove: () => void;
    @Input() public extendedTechReject: () => void;

    public extendedTechApproveAction: string;
    public datasetFile: File;

    private popupInstance: DxPopup | undefined;

    public constructor(
        private readonly messageBox: MessageBox,
    ) {
    }

    public onPopupInstanceCreated(popup: DxPopup): void {
        this.popupInstance = popup;
        this.updateButtons();
    }

    private updateButtons(): void {
        if (!this.popupInstance) {
            return;
        }

        const toolbarItems = [this.messageBox.createSecondaryButton("NAVIGATION.ABORT", () => this.cancel())];
        this.addRejectOrApproveButton(toolbarItems);

        this.popupInstance.beginUpdate();
        this.popupInstance.instance().option("toolbarItems", toolbarItems);
        this.popupInstance.endUpdate();
    }

    private addRejectOrApproveButton(toolbarItems: IToolbarItem[]): void {
        if (this.extendedTechApproveAction === "extendedTechApprove" && this.datasetFile) {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.OKAY",
                () => this.approve(),
            ));
        } else if (this.extendedTechApproveAction === "extendedTechReject" && this.datasetFile) {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.NOT_OKAY",
                () => this.reject(),
            ));
        }
    }

    public onExtendedTechApproveActionChanged(): void {
        this.updateButtons();
    }

    public onExtendedTechnicalCheckNoteChanged(): void {
        this.updateButtons();
    }

    public cancel(): void {
        this.messageBox.hideAll();
    }

    public onFileSelected(files: File[]): void {
        this.datasetFile = files[0];
        this.onFileSelect(files);
        this.updateButtons();
    }

    public approve(): void {
        this.extendedTechApprove();
        this.cancel();
    }

    public reject(): void {
        this.extendedTechReject();
        this.cancel();
    }

}
